import React, { useEffect, useState } from 'react'

import { getPriorityList } from '../../../API/Planning/MasterWip/MasterWipRequest';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { formatProductionCard } from '../../../Base/Services/TemplatesServices';


const PriorityListScreen = ({ get = 1, statusTemplate }) => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [week, setWeek] = useState(null)


    const getInfo = async () => {
        setLoading(true);
        const res = await getPriorityList();
        console.log(res);
        setData(res);
        const target = new Date();
        const dayNum = target.getUTCDay() || 7; // Si es domingo, convertir a 7
        target.setUTCDate(target.getUTCDate() + 4 - dayNum); // Ajustar al jueves en la semana actual
        const yearStart = new Date(Date.UTC(target.getUTCFullYear(), 0, 1));
        const weekNumber = Math.ceil(((target - yearStart) / 86400000 + 1) / 7);
        console.log(typeof (weekNumber + ""));
        setWeek(weekNumber + "");
        setLoading(false);
    }

    const rowClassRules = {
        'ag-rows-partida-red': (params) => { return params?.data?.Cumplimiento === 'PD' },
        'ag-rows-background-skype': (params) => { return params?.data?.ExportWeek === week },
    }

    const columns = [
        {
            field: 'IdCreateDate',
            header: 'Create Date',
            headerEn: '',
            Format: 'Date',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            headerName: 'Revisión',
            headerEn: 'Revision',
            children: [
                {
                    field: 'RevExportWeek',
                    header: 'Export Week',
                    headerEn: '',
                    className: 'XXsmall',
                    Format: 'Center',
                    Frozen: true,
                    alignFrozen: 'left',
                },
                {
                    field: 'IdRevColorDate',
                    header: 'Color Date',
                    headerEn: '',
                    className: 'XXsmall',
                    Format: 'Date',
                    Frozen: true,
                    alignFrozen: 'left',
                },

            ]
        },
        {
            headerName: 'Planning',
            children: [
                {
                    field: 'ExportWeek',
                    header: 'Export Week',
                    headerEn: '',
                    className: 'XXsmall',
                    Format: 'Center',
                    Frozen: true,
                    alignFrozen: 'left',
                },
                {
                    field: 'IdColorPlanningDate',
                    header: 'Fecha Color Planning',
                    headerEn: 'Color Planning Date',
                    Format: 'Date',
                    Frozen: true,
                    alignFrozen: 'left',
                },
                {
                    field: 'IdPlanningDate',
                    header: 'Fecha Planning',
                    headerEn: 'Planning Date',
                    Format: 'Date',
                    Frozen: true,
                    alignFrozen: 'left',
                },

            ]
        },
        {
            field: 'Estado',
            header: 'Estado',
            headerEn: '',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
            Format: 'Template',
            body: statusTemplate
        },
        {
            field: 'SalesOrder',
            header: 'Sales Order',
            headerEn: '',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
            Sumary: 'count',
        },
        {
            field: 'CustomerOrder',
            header: 'Customer Order',
            headerEn: '',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'ProductionCard',
            header: 'Production Card',
            headerEn: '',
            className: 'small',
            Format: 'Template',
            body: e => {
                return <div className='col-12 text-center'>{formatProductionCard(e?.ProductionCard)}</div>
            },
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'Customer',
            header: 'Customer',
            headerEn: '',
            className: '',
        },
        {
            field: 'Buyer',
            header: 'Buyer',
            headerEn: '',
            className: 'Xsmall',
        },
        {
            field: 'Season',
            header: 'Season',
            headerEn: '',
            className: 'Xsmall',
        },
        {
            field: 'StyleCategory',
            header: 'Style Category',
            headerEn: '',
            className: 'Xsmall',
        },
        {
            field: 'Style',
            header: 'Style',
            headerEn: '',
            className: 'XXlarge',
        },
        {
            field: 'With',
            header: 'With',
            headerEn: '',
            className: 'Xsmall',
        },
        {
            field: 'Color',
            header: 'Color',
            headerEn: '',
            className: 'small',
        },
        {
            field: 'DyeMachine',
            header: 'DyeMachine',
            headerEn: '',
            className: 'small',
        },
        {
            field: 'DyeGroup',
            header: 'DyeGroup',
            headerEn: '',
            className: 'small',
        },
        {
            field: 'Stage',
            header: 'Stage',
            headerEn: '',
            className: 'Xsmall',
        },
        {
            field: 'Process',
            header: 'Process',
            headerEn: '',
            className: 'small',
        },
        {
            field: 'Subcategory',
            header: 'Subcategory',
            headerEn: '',
            className: 'small',
        },
        {
            headerName: 'Laboratorio',
            children: [
                {
                    field: 'ComentarioLabPL',
                    header: 'Comentario',
                    headerEn: 'Comment',
                    className: 'Xlarge',
                },
                {
                    field: 'IdFechaLabPL',
                    header: 'Fecha',
                    headerEn: 'Date',
                    Format: 'Date',
                },

            ]
        },
        {
            headerName: 'Tintoreria',
            headerEn: 'Dye',
            children: [
                {
                    field: 'ComentarioTintoPL',
                    header: 'Comentario',
                    headerEn: 'Comment',
                    className: 'Xlarge',
                },
                {
                    field: 'IdFechaTintoPL',
                    header: 'Fecha',
                    headerEn: 'Date',
                    // Format: 'Date',
                },
            ]
        },
        {
            headerName: 'Acabado',
            headerEn: 'Finish',
            children: [
                {
                    field: 'MaquinaAcabado',
                    header: 'MaquinaAcabado',
                    headerEn: '',
                    className: 'small',
                },
                {
                    field: 'ComentarioAcaPL',
                    header: 'Comentario',
                    headerEn: 'Comment',
                    className: '',
                },
                {
                    field: 'IdFechaAcaPL',
                    header: 'Fecha',
                    headerEn: 'Date',
                    Format: 'Date',
                },
            ]
        },
        {
            headerName: 'Calidad',
            children: [
                {
                    field: 'ComentarioQCPL',
                    header: 'Comentario',
                    headerEn: 'Comment',
                    className: '',
                },
                {
                    field: 'IdFechaQCPL',
                    header: 'Fecha',
                    headerEn: 'Date',
                    Format: 'Date',
                },
                {
                    field: 'DiasEnQC',
                    header: 'Dias En QC',
                    headerEn: 'Days In QC',
                    className: 'Xsmall',
                },
            ]
        },
        {
            headerName: 'Order',
            children: [
                {
                    field: 'KgEsperados',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'YdsEsperadas',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Request',
            children: [
                {
                    field: 'WKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'WYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Batching',
            children: [
                {
                    field: 'GKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'GYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Tintoreria',
            headerEn: 'Dye',
            children: [
                {
                    field: 'TintoKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'TintoYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Acabado',
            headerEn: 'Finish',
            children: [
                {
                    field: 'AcaGKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },

            ]
        },
        {
            headerName: 'Calidad',
            headerEn: 'Quality',
            children: [
                {
                    headerName: 'A',
                    children: [
                        {
                            field: 'AcabadoKg',
                            header: 'Kgs',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: 'AcabadoYd',
                            header: 'Yds',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                    ]
                },
                {
                    headerName: 'B',
                    children: [
                        {
                            field: 'ACA_BKg',
                            header: 'Kgs',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: 'ACA_BYd',
                            header: 'Yds',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                    ]
                },
                {
                    headerName: 'C',
                    children: [
                        {
                            field: 'ACA_CKg',
                            header: 'Kgs',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: 'ACA_CYd',
                            header: 'Yds',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                    ]
                },
            ]
        },
        {
            headerName: 'Export',
            children: [
                {
                    field: 'ExportadoKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'ExportadoYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'Cumplimiento',
                    header: 'Cumplimiento',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Template',
                    body: e => {
                        return <div className='text-bold text-center col-12'>{e.Cumplimiento}</div>
                    },
                    Frozen: true,
                    alignFrozen: 'right',
                },
            ]
        },
    ]

    const table = {
        Columns: columns,
        Data: data,
        loading: loading,
        rowClassRules: rowClassRules
    }


    useEffect(() => {
        getInfo();
    }, [get])

    return (
        <div style={{ height: '85vh', }} className='p-3'>
            <AgGrid table={table} />
        </div>
    )
}

export default PriorityListScreen